export const MARRY_STATUS_OPTIONS = ['单身', '已婚', '丧偶', '离异']

/** 申请类型为单身人士时，婚姻现状不可选已婚 */
export const isMarryOptionDisabledForApplyType = (marry, applyType) => (
    applyType === '单身人士' && marry === '已婚'
)

export const isApplyTypeOptionDisabledForMarry = (applyType, marry) => (
    marry === '已婚' && applyType === '单身人士'
)

export const getApplyTypeMarryConflictMessage = (applyType, marry) => {
    if (applyType === '单身人士' && marry === '已婚') {
        return '申请类型为单身人士时，婚姻现状不能选择已婚'
    }
    return ''
}
